"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[91459],{

/***/ 13195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./components/_stores/is-globally-mounted-store.tsx
var is_globally_mounted_store = __webpack_require__(55041);
// EXTERNAL MODULE: ./components/_stores/preloaded-images-store.tsx
var preloaded_images_store = __webpack_require__(80834);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/_hooks/use-preload-image.tsx





var usePreloadImage = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,is_globally_mounted_store/* useIsGloballyMounted */.j)(), 1), isMounted = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,preloaded_images_store/* usePreloadedImages */.M)(), 2), preloadedImages = ref1[0], setPreloadedImages = ref1[1];
    return (0,react.useCallback)(function(param) {
        var src = param.src, width = param.width, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality;
        if (!isMounted) return;
        var imageString = "".concat(src.replace(/^\/\//, "https://"), "_").concat(width, "_").concat(quality);
        var _1xSize = [
            16,
            32,
            48,
            64,
            96,
            128,
            256,
            384,
            460,
            640,
            750,
            828,
            1080,
            1200,
            1920,
            2048,
            3840, 
        ].filter(function(size) {
            return size >= width;
        })[0];
        var _2xSize = [
            16,
            32,
            48,
            64,
            96,
            128,
            256,
            384,
            460,
            640,
            750,
            828,
            1080,
            1200,
            1920,
            2048,
            3840, 
        ].filter(function(size) {
            return size >= width * 2;
        })[0];
        var preloadSrcset = "/_next/image?url=".concat(encodeURIComponent(src.replace(/^\/\//, "https://")), "&w=").concat(_1xSize, "&q=").concat(quality, " 1x, /_next/image?url=").concat(encodeURIComponent(src.replace(/^\/\//, "https://")), "&w=").concat(_2xSize, "&q=").concat(quality, " 2x");
        if (preloadedImages.includes(imageString)) {
            return;
        }
        setPreloadedImages(function(currentPreloadImages) {
            return (0,_to_consumable_array/* default */.Z)(currentPreloadImages).concat([
                imageString
            ]);
        });
        var link = document.createElement("link");
        link.rel = "preload";
        link.as = "image";
        link.imageSrcset = preloadSrcset;
        document.head.appendChild(link);
    // new Image().src = preloadSrcset;
    }, [
        isMounted,
        preloadedImages,
        setPreloadedImages
    ]);
};
/* harmony default export */ var use_preload_image = (usePreloadImage);

// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./components/image.tsx







var Image = function(_param) {
    var _pixelDensity = _param.pixelDensity, pixelDensity = _pixelDensity === void 0 ? 1 : _pixelDensity, preload = _param.preload, props = (0,_object_without_properties/* default */.Z)(_param, [
        "pixelDensity",
        "preload"
    ]);
    var preloadImage = use_preload_image();
    var src = props.src, width = props.width, height = props.height, maxWidth = props.maxWidth, maxHeight = props.maxHeight, aspectRatio = props.aspectRatio, rest = (0,_object_without_properties/* default */.Z)(props, [
        "src",
        "width",
        "height",
        "maxWidth",
        "maxHeight",
        "aspectRatio"
    ]);
    var aspect = aspectRatio !== null && aspectRatio !== void 0 ? aspectRatio : +width / +height;
    (0,react.useEffect)(function() {
        if (src && typeof src === "string") {
            if (preload) {
                preloadImage({
                    src: src,
                    quality: props.quality ? +props.quality : 75,
                    width: maxWidth ? maxWidth : maxHeight ? maxHeight * aspect : +width
                });
            }
            if (!preload) {
                preloadImage({
                    src: src,
                    quality: 1,
                    width: 32
                });
            }
        }
    }, [
        aspect,
        maxHeight,
        maxWidth,
        preload,
        preloadImage,
        props.quality,
        src,
        width
    ]);
    if (!src || src === "undefined") {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        priority: typeof src !== "string" && preload || rest.priority,
        placeholder: !preload ? "blur" : undefined,
        blurDataURL: typeof src === "string" && !preload ? "/_next/image?url=".concat(encodeURIComponent(src.replace(/^(http:)?\/\//, "https://")), "&w=32&q=1") : undefined,
        src: typeof src === "string" ? src.replace(/^(http:)?\/\//, "https://") : src,
        width: Math.round(+(maxWidth ? maxWidth : maxHeight ? maxHeight * aspect : width) * pixelDensity),
        height: Math.round(+(maxHeight ? maxHeight : maxWidth ? maxWidth / aspect : height) * pixelDensity)
    }));
};


/***/ }),

/***/ 21222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ TECH; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ai/AiOutlineConsoleSql.js
var AiOutlineConsoleSql = __webpack_require__(53021);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaAws.js
var FaAws = __webpack_require__(81031);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/im/ImUpload.js
var ImUpload = __webpack_require__(7417);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoLogoSass.js
var IoLogoSass = __webpack_require__(62352);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoLogoVercel.js
var IoLogoVercel = __webpack_require__(76062);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/md/MdDesktopMac.js
var MdDesktopMac = __webpack_require__(67553);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiAdobeillustrator.js
var SiAdobeillustrator = __webpack_require__(13471);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiAdobephotoshop.js
var SiAdobephotoshop = __webpack_require__(53280);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiCss3.js
var SiCss3 = __webpack_require__(60733);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiEslint.js
var SiEslint = __webpack_require__(89507);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiFacebook.js
var SiFacebook = __webpack_require__(65886);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiFigma.js
var SiFigma = __webpack_require__(90022);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiFirebase.js
var SiFirebase = __webpack_require__(71759);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiFramer.js
var SiFramer = __webpack_require__(44765);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiGit.js
var SiGit = __webpack_require__(18584);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiGithub.js
var SiGithub = __webpack_require__(41416);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiGooglechrome.js
var SiGooglechrome = __webpack_require__(11257);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiGraphql.js
var SiGraphql = __webpack_require__(83553);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiHtml5.js
var SiHtml5 = __webpack_require__(61310);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiInstagram.js
var SiInstagram = __webpack_require__(90704);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiIntellijidea.js
var SiIntellijidea = __webpack_require__(97069);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiIonic.js
var SiIonic = __webpack_require__(54061);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiJavascript.js
var SiJavascript = __webpack_require__(2365);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiJest.js
var SiJest = __webpack_require__(78076);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiMarkdown.js
var SiMarkdown = __webpack_require__(71907);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiMicrosoftoffice.js
var SiMicrosoftoffice = __webpack_require__(11353);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiMicrosoftteams.js
var SiMicrosoftteams = __webpack_require__(59455);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiMysql.js
var SiMysql = __webpack_require__(89974);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiNetlify.js
var SiNetlify = __webpack_require__(97616);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiNodeDotJs.js
var SiNodeDotJs = __webpack_require__(22555);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiNpm.js
var SiNpm = __webpack_require__(38946);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiPhp.js
var SiPhp = __webpack_require__(11960);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiPostman.js
var SiPostman = __webpack_require__(51574);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiPrettier.js
var SiPrettier = __webpack_require__(51058);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiReact.js
var SiReact = __webpack_require__(64658);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiRedis.js
var SiRedis = __webpack_require__(4970);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiRuby.js
var SiRuby = __webpack_require__(4095);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiShopify.js
var SiShopify = __webpack_require__(58493);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiSketch.js
var SiSketch = __webpack_require__(65759);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiTailwindcss.js
var SiTailwindcss = __webpack_require__(51870);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiTypescript.js
var SiTypescript = __webpack_require__(40903);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiWebpack.js
var SiWebpack = __webpack_require__(36268);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiWordpress.js
var SiWordpress = __webpack_require__(89996);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiYarn.js
var SiYarn = __webpack_require__(708);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiJava.js
var SiJava = __webpack_require__(71457);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiKotlin.js
var SiKotlin = __webpack_require__(49891);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiJenkins.js
var SiJenkins = __webpack_require__(41764);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiSpring.js
var SiSpring = __webpack_require__(93724);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/tech-logos/aws_amplify.svg
var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAwsAmplify = function SvgAwsAmplify(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 256 191",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    x1: "100%",
    y1: "22.172%",
    x2: "0%",
    y2: "77.828%",
    id: "aws_amplify_svg__a"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#F90",
    offset: "0%"
  }), /*#__PURE__*/react.createElement("stop", {
    stopColor: "#FFC300",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M55.71 158.476h72.106l18.47 32.508H0l51.364-89.006L72.89 64.706l18.48 32.022-35.66 61.748ZM82.6 47.85l17.744-30.746 100.42 173.88h-35.562L82.601 47.85ZM110.221 0h35.516L256 190.984h-35.56L110.22 0Z",
    fill: "url(#aws_amplify_svg__a)"
  })));
};
/* harmony default export */ var aws_amplify = (SvgAwsAmplify);
;// CONCATENATED MODULE: ./public/icons/tech-logos/aws_lambda.svg
var aws_lambda_defs, aws_lambda_path, _path2;
function aws_lambda_extends() { aws_lambda_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return aws_lambda_extends.apply(this, arguments); }

var SvgAwsLambda = function SvgAwsLambda(props) {
  return /*#__PURE__*/react.createElement("svg", aws_lambda_extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), aws_lambda_defs || (aws_lambda_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "aws_lambda_svg__a"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/react.createElement("stop", {
    stopColor: "#F90",
    offset: "100%"
  })))), aws_lambda_path || (aws_lambda_path = /*#__PURE__*/react.createElement("path", {
    fill: "url(#aws_lambda_svg__a)",
    d: "M0 0h256v256H0z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M89.624 211.2H49.89l43.945-91.853 19.912 40.992L89.624 211.2Zm7.079-100.63a3.216 3.216 0 0 0-2.887-1.805h-.01a3.204 3.204 0 0 0-2.886 1.82L41.913 213.022a3.203 3.203 0 0 0 2.893 4.58l46.848-.001a3.21 3.21 0 0 0 2.9-1.83l25.65-54.08a3.183 3.183 0 0 0-.016-2.762L96.703 110.57ZM207.985 211.2h-39.477L105.174 78.624a3.206 3.206 0 0 0-2.897-1.824h-25.83l.03-32h50.626l63.042 132.573a3.209 3.209 0 0 0 2.897 1.827h14.943v32Zm3.208-38.4h-16.121L132.03 40.227a3.21 3.21 0 0 0-2.9-1.827H73.273a3.206 3.206 0 0 0-3.208 3.197l-.035 38.4c0 .851.333 1.664.94 2.265.6.602 1.414.938 2.267.938h27.017l63.337 132.576a3.205 3.205 0 0 0 2.893 1.824h44.709a3.203 3.203 0 0 0 3.207-3.2V176c0-1.766-1.434-3.2-3.207-3.2Z",
    fill: "#FFF"
  })));
};
/* harmony default export */ var aws_lambda = (SvgAwsLambda);
;// CONCATENATED MODULE: ./public/icons/tech-logos/axios.svg
var axios_path;
function axios_extends() { axios_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return axios_extends.apply(this, arguments); }

var SvgAxios = function SvgAxios(props) {
  return /*#__PURE__*/react.createElement("svg", axios_extends({
    viewBox: "0 0 512 75",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), axios_path || (axios_path = /*#__PURE__*/react.createElement("path", {
    d: "M254.114 9.182v60.165l-6.557 5.282v-50.05h-12.343l18.9-15.397ZM481.537 0c5.492 0 10.59.828 15.297 2.484 4.528 1.564 8.433 3.323 11.717 5.275l.573.347-6.799 12.943c-.62-.507-1.496-1.088-2.627-1.741l-.643-.364-.693-.378-.743-.393c-2.092-1.133-4.576-2.092-7.453-2.876a30.487 30.487 0 0 0-8.89-1.308c-8.193 0-12.29 2.31-12.29 6.93 0 2.701 1.482 4.619 4.445 5.752l.676.245.717.249.76.253.804.256.846.261.888.265c.152.045.305.09.46.134l.953.27.995.276 1.038.278 1.08.283 1.124.287 1.765.438 1.23.297c5.142 1.307 9.588 2.789 13.336 4.445 3.675 1.587 6.51 3.694 8.504 6.322l.255.346c2.092 2.702 3.138 6.275 3.138 10.72 0 5.404-1.395 9.762-4.184 13.075-2.702 3.224-6.275 5.578-10.72 7.06-4.446 1.394-9.24 2.091-14.382 2.091-5.927 0-11.81-.828-17.65-2.484-5.562-1.577-10.53-3.707-14.906-6.391l-.652-.407 7.06-13.728c1.133 1.133 3.007 2.397 5.622 3.791 2.702 1.395 5.84 2.572 9.413 3.53 3.574.96 7.365 1.439 11.375 1.439 8.018 0 12.028-2.136 12.028-6.407 0-2.876-1.874-4.924-5.622-6.144l-.901-.317-.947-.321-.991-.326-1.037-.332-1.082-.336-1.127-.342-.58-.172-1.195-.349-1.24-.354-1.286-.359-1.33-.364-2.08-.555-.716-.188c-7.496-1.917-13.074-4.358-16.735-7.321-3.574-3.051-5.36-7.41-5.36-13.075 0-5.055 1.263-9.282 3.79-12.681 2.616-3.4 6.102-5.971 10.46-7.714C471.47.872 476.308 0 481.537 0ZM360.292.13c5.531 0 10.581 1.008 15.146 3.023l.545.246c4.707 2.092 8.716 4.925 12.028 8.498 3.4 3.487 6.012 7.453 7.842 11.898 1.83 4.445 2.748 8.977 2.748 13.597 0 4.794-.958 9.413-2.876 13.859-1.917 4.358-4.622 8.28-8.109 11.766-3.399 3.4-7.449 6.101-12.156 8.106-4.706 2.005-9.849 3.007-15.427 3.007-5.753 0-10.982-1.002-15.689-3.007-4.707-2.092-8.762-4.88-12.162-8.367-3.399-3.574-6.014-7.583-7.844-12.028-1.828-4.446-2.746-9.022-2.746-13.728 0-4.794.96-9.414 2.877-13.859a36.412 36.412 0 0 1 7.638-11.3l.47-.467c3.487-3.486 7.58-6.232 12.287-8.236 4.707-2.005 9.85-3.007 15.428-3.007ZM44.844.524l31.77 73.084H59.88L52.558 56.48H24.187l-7.321 17.127H0L31.9.523h12.944Zm93.58 0L158.56 26.41 178.693.523h17.127l-28.894 37 27.979 36.084h-17.127l-19.22-24.84-19.087 24.84h-17.389l28.11-36.084-29.025-37h17.258ZM266.106.188v48.905h12.689L259.56 64.877V4.744l6.544-4.556Zm93.928 14.063c-4.794 0-8.893 1.133-12.292 3.399-3.313 2.266-5.84 5.142-7.583 8.629-1.744 3.486-2.615 7.104-2.615 10.852 0 3.922.918 7.67 2.748 11.243 1.828 3.487 4.399 6.32 7.711 8.498 3.4 2.18 7.452 3.269 12.159 3.269 4.794 0 8.847-1.133 12.159-3.4 3.315-2.353 5.84-5.273 7.583-8.76 1.743-3.573 2.617-7.233 2.617-10.981 0-3.922-.915-7.627-2.745-11.113-1.83-3.487-4.445-6.276-7.847-8.368-3.313-2.179-7.276-3.268-11.895-3.268ZM38.438 19.74 27.717 42.753h21.05l-10.33-23.01Z",
    fill: "#5A29E4"
  })));
};
/* harmony default export */ var axios = (SvgAxios);
;// CONCATENATED MODULE: ./public/icons/tech-logos/emmet.svg
var _circle, emmet_path, emmet_path2;
function emmet_extends() { emmet_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return emmet_extends.apply(this, arguments); }

var SvgEmmet = function SvgEmmet(props) {
  return /*#__PURE__*/react.createElement("svg", emmet_extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    fill: "#1C1C20",
    cx: 127.555,
    cy: 128.184,
    r: 127.555
  })), emmet_path || (emmet_path = /*#__PURE__*/react.createElement("path", {
    d: "m178.496 124.737-14.205-14.205 7.306-30.035-30.441 6.9-13.8-13.8 68.187-17.047-17.047 68.187Z",
    fill: "#BAFFA9"
  })), emmet_path2 || (emmet_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M154.956 218.901 33.192 97.138 101.38 80.09l13.8 13.8-48.706 12.176 27.6 27.6 32.064-7.712-8.117 31.658 27.6 27.6 12.176-48.705 14.205 14.206-17.046 68.187Z",
    fill: "#7ACB16"
  })));
};
/* harmony default export */ var emmet = (SvgEmmet);
;// CONCATENATED MODULE: ./public/icons/tech-logos/headlessui.svg
var headlessui_defs, headlessui_path, headlessui_path2;
function headlessui_extends() { headlessui_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return headlessui_extends.apply(this, arguments); }

var SvgHeadlessui = function SvgHeadlessui(props) {
  return /*#__PURE__*/react.createElement("svg", headlessui_extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), headlessui_defs || (headlessui_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    x1: "35.871%",
    y1: "7.224%",
    x2: "60.314%",
    y2: "115.988%",
    id: "headlessui_svg__a"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#66E3FF",
    offset: "0%"
  }), /*#__PURE__*/react.createElement("stop", {
    stopColor: "#7064F9",
    offset: "100%"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    x1: "39.172%",
    y1: "0%",
    x2: "55.05%",
    y2: "99.181%",
    id: "headlessui_svg__b"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#66E3FF",
    offset: "0%"
  }), /*#__PURE__*/react.createElement("stop", {
    stopColor: "#7064F9",
    offset: "100%"
  })))), headlessui_path || (headlessui_path = /*#__PURE__*/react.createElement("path", {
    d: "m50.699 159.089 156.225-52.153c-3.122-19.523-5.346-32.565-7.924-42.518-2.777-10.706-4.978-13.57-5.842-14.563a30.468 30.468 0 0 0-10.973-7.969c-1.216-.52-4.625-1.728-15.654-1.064-11.669.704-26.987 3.088-51.245 6.929-24.25 3.84-39.56 6.313-50.87 9.241-10.7 2.777-13.573 4.985-14.566 5.85a30.581 30.581 0 0 0-7.963 10.97c-.52 1.215-1.729 4.624-1.064 15.658.704 11.665 3.089 26.988 6.93 51.24 1.073 6.8 2.041 12.882 2.946 18.379Z",
    fill: "url(#headlessui_svg__a)"
  })), headlessui_path2 || (headlessui_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M7.625 147.063c-7.427-46.92-11.149-70.38-3.098-89.214a71.092 71.092 0 0 1 18.6-25.605c15.423-13.466 38.88-17.178 85.796-24.611C155.854.19 179.313-3.521 198.16 4.528a71.085 71.085 0 0 1 25.595 18.595c13.477 15.426 17.19 38.886 24.618 85.814 7.435 46.92 11.149 70.387 3.097 89.214a71.076 71.076 0 0 1-18.591 25.604c-15.423 13.474-38.889 17.187-85.812 24.62-46.916 7.433-70.382 11.146-89.213 3.096a71.093 71.093 0 0 1-25.595-18.595C18.781 217.45 15.068 193.99 7.633 147.063h-.008Zm82.762 83.325c12.565-.76 28.748-3.296 52.702-7.09 23.962-3.792 40.12-6.384 52.318-9.545 11.805-3.064 17.247-6.049 20.76-9.121a45.696 45.696 0 0 0 11.95-16.459c1.84-4.288 3-10.385 2.264-22.563-.76-12.562-3.297-28.749-7.09-52.705-3.794-23.955-6.38-40.126-9.54-52.312-3.066-11.81-6.059-17.25-9.124-20.763a45.699 45.699 0 0 0-16.455-11.954c-4.29-1.84-10.388-3-22.57-2.265-12.565.76-28.74 3.297-52.701 7.09-23.954 3.8-40.121 6.385-52.31 9.545-11.813 3.065-17.247 6.057-20.76 9.122a45.704 45.704 0 0 0-11.958 16.458c-1.833 4.289-2.993 10.386-2.257 22.564.76 12.57 3.29 28.748 7.091 52.704 3.794 23.956 6.379 40.127 9.54 52.313 3.065 11.81 6.05 17.25 9.124 20.763a45.707 45.707 0 0 0 16.455 11.954c4.29 1.84 10.38 3 22.57 2.264h-.009Z",
    fill: "url(#headlessui_svg__b)"
  })));
};
/* harmony default export */ var headlessui = (SvgHeadlessui);
;// CONCATENATED MODULE: ./public/icons/tech-logos/jsdom.svg
var jsdom_path, jsdom_path2;
function jsdom_extends() { jsdom_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return jsdom_extends.apply(this, arguments); }

var SvgJsdom = function SvgJsdom(props) {
  return /*#__PURE__*/react.createElement("svg", jsdom_extends({
    viewBox: "0 0 256 287",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), jsdom_path || (jsdom_path = /*#__PURE__*/react.createElement("path", {
    d: "m240.403 225.915-97.117 56.04a29.93 29.93 0 0 1-30.886 0l-97.116-56.04C5.73 220.183 0 209.995 0 199.168V87.086C0 75.942 5.731 66.071 15.284 60.34L112.4 4.3c9.553-5.732 21.016-5.732 30.886 0l97.117 56.04c9.552 5.732 15.284 15.921 15.284 26.747v112.082a29.613 29.613 0 0 1-15.284 26.747Z",
    fill: "#DBC01D"
  })), jsdom_path2 || (jsdom_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M106.98 54.607s.32 18.15-7.004 39.164c-5.095 14.966-12.1 22.608-28.658 39.802-7.96 7.96-30.249 27.702-47.125 49.036a182.77 182.77 0 0 0-20.378 30.886s2.865 7.324 11.78 12.737l23.563 13.692 10.827-17.832c4.776-7.323 12.736-17.194 12.736-17.194l25.473 38.847 36.618-24.518-30.886-46.17s14.647-14.01 18.468-18.468l10.189-11.782s15.602 9.234 21.652 13.374c8.916 5.731 20.379 14.965 20.379 14.965l-32.16 48.08 36.617 24.519 26.747-39.802 14.966 21.652c3.502 5.413 7.323 13.373 7.323 13.373l22.29-12.736c9.233-5.413 12.736-14.329 12.736-14.329s-9.871-17.831-18.787-29.612c-9.234-12.419-22.289-26.429-28.339-32.797-10.826-10.508-29.612-25.155-39.164-31.523-8.598-5.732-23.882-14.01-23.882-14.01s3.503-9.871 5.732-24.518c1.274-8.916 1.91-23.881 1.91-23.881l-43.622-.955Z",
    fill: "#383307"
  })));
};
/* harmony default export */ var jsdom = (SvgJsdom);
;// CONCATENATED MODULE: ./public/icons/tech-logos/mdx.svg
var mdx_path, mdx_path2, _path3, _path4;
function mdx_extends() { mdx_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mdx_extends.apply(this, arguments); }

var SvgMdx = function SvgMdx(props) {
  return /*#__PURE__*/react.createElement("svg", mdx_extends({
    viewBox: "0 0 512 212",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), mdx_path || (mdx_path = /*#__PURE__*/react.createElement("path", {
    d: "M19.478 2.783h473.044c9.22 0 16.695 7.475 16.695 16.695V192c0 9.22-7.475 16.696-16.695 16.696H19.478c-9.22 0-16.695-7.475-16.695-16.696V19.478c0-9.22 7.475-16.695 16.695-16.695Z",
    fill: "#FFF"
  })), mdx_path2 || (mdx_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M19.478 0h473.044C503.279 0 512 8.72 512 19.478V192c0 10.758-8.72 19.478-19.478 19.478H19.478C8.721 211.478 0 202.758 0 192V19.478C0 8.721 8.72 0 19.478 0Zm0 5.565c-7.684 0-13.913 6.23-13.913 13.913V192c0 7.684 6.23 13.913 13.913 13.913h473.044c7.684 0 13.913-6.229 13.913-13.913V19.478c0-7.684-6.23-13.913-13.913-13.913H19.478Z",
    fill: "#EAEAEA"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "m272.696 40.203-.002 84.896L303.88 93.92l15.74 15.741-57.642 57.638-58.37-58.369 15.742-15.74 31.085 31.084V40.203zM72.162 162.98V97.231l40.255 40.257 40.56-40.557v65.383h22.26V43.192l-62.819 62.816-62.517-62.521v119.492z"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#F9AC00",
    d: "m447.847 36.651 15.74 15.741-47.15 47.147 45.7 45.7-15.74 15.742-45.701-45.7-45.7 45.7-15.741-15.741 45.695-45.7-47.146-47.148 15.74-15.74 47.152 47.145z"
  })));
};
/* harmony default export */ var mdx = (SvgMdx);
;// CONCATENATED MODULE: ./public/icons/tech-logos/planetscale.svg
var planetscale_path;
function planetscale_extends() { planetscale_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return planetscale_extends.apply(this, arguments); }

var SvgPlanetscale = function SvgPlanetscale(props) {
  return /*#__PURE__*/react.createElement("svg", planetscale_extends({
    className: "planetscale_svg__flex-shrink-0 planetscale_svg__block",
    width: 36,
    height: 36,
    viewBox: "0 0 44 44",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), planetscale_path || (planetscale_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 22C0 9.85 9.85 0 22 0c8.934 0 16.623 5.325 20.069 12.974L12.974 42.069a21.964 21.964 0 0 1-3.547-2.014L27.482 22H22L6.444 37.556A21.931 21.931 0 0 1 0 22ZM44 22.008 22.008 44C34.152 43.996 43.996 34.152 44 22.008Z"
  })));
};
/* harmony default export */ var planetscale = (SvgPlanetscale);
;// CONCATENATED MODULE: ./public/icons/tech-logos/preact.svg
var preact_path, preact_path2, preact_path3, preact_path4;
function preact_extends() { preact_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return preact_extends.apply(this, arguments); }

var SvgPreact = function SvgPreact(props) {
  return /*#__PURE__*/react.createElement("svg", preact_extends({
    viewBox: "0 0 256 296",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), preact_path || (preact_path = /*#__PURE__*/react.createElement("path", {
    fill: "#673AB8",
    d: "m128 0 128 73.9v147.8l-128 73.9L0 221.7V73.9z"
  })), preact_path2 || (preact_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M34.865 220.478c17.016 21.78 71.095 5.185 122.15-34.704 51.055-39.888 80.24-88.345 63.224-110.126-17.017-21.78-71.095-5.184-122.15 34.704-51.055 39.89-80.24 88.346-63.224 110.126Zm7.27-5.68c-5.644-7.222-3.178-21.402 7.573-39.253 11.322-18.797 30.541-39.548 54.06-57.923 23.52-18.375 48.303-32.004 69.281-38.442 19.922-6.113 34.277-5.075 39.92 2.148 5.644 7.223 3.178 21.403-7.573 39.254-11.322 18.797-30.541 39.547-54.06 57.923-23.52 18.375-48.304 32.004-69.281 38.441-19.922 6.114-34.277 5.076-39.92-2.147Z",
    fill: "#FFF"
  })), preact_path3 || (preact_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M220.239 220.478c17.017-21.78-12.169-70.237-63.224-110.126C105.96 70.464 51.88 53.868 34.865 75.648c-17.017 21.78 12.169 70.238 63.224 110.126 51.055 39.889 105.133 56.485 122.15 34.704Zm-7.27-5.68c-5.643 7.224-19.998 8.262-39.92 2.148-20.978-6.437-45.761-20.066-69.28-38.441-23.52-18.376-42.74-39.126-54.06-57.923-10.752-17.851-13.218-32.03-7.575-39.254 5.644-7.223 19.999-8.261 39.92-2.148 20.978 6.438 45.762 20.067 69.281 38.442 23.52 18.375 42.739 39.126 54.06 57.923 10.752 17.85 13.218 32.03 7.574 39.254Z",
    fill: "#FFF"
  })), preact_path4 || (preact_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M127.552 167.667c10.827 0 19.603-8.777 19.603-19.604 0-10.826-8.776-19.603-19.603-19.603-10.827 0-19.604 8.777-19.604 19.603 0 10.827 8.777 19.604 19.604 19.604Z",
    fill: "#FFF"
  })));
};
/* harmony default export */ var preact = (SvgPreact);
;// CONCATENATED MODULE: ./public/icons/tech-logos/prisma.svg
var prisma_path;
function prisma_extends() { prisma_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return prisma_extends.apply(this, arguments); }

var SvgPrisma = function SvgPrisma(props) {
  return /*#__PURE__*/react.createElement("svg", prisma_extends({
    viewBox: "0 0 256 310",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), prisma_path || (prisma_path = /*#__PURE__*/react.createElement("path", {
    d: "M254.313 235.519 148 9.749A17.063 17.063 0 0 0 133.473.037a16.87 16.87 0 0 0-15.533 8.052L2.633 194.848a17.465 17.465 0 0 0 .193 18.747L59.2 300.896a18.13 18.13 0 0 0 20.363 7.489l163.599-48.392a17.929 17.929 0 0 0 11.26-9.722 17.542 17.542 0 0 0-.101-14.76l-.008.008Zm-23.802 9.683-138.823 41.05c-4.235 1.26-8.3-2.411-7.419-6.685l49.598-237.484c.927-4.443 7.063-5.147 9.003-1.035l91.814 194.973a6.63 6.63 0 0 1-4.18 9.18h.007Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ var prisma = (SvgPrisma);
;// CONCATENATED MODULE: ./public/icons/tech-logos/react_query.svg
var react_query_path, react_query_path2, react_query_path3, react_query_path4;
function react_query_extends() { react_query_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return react_query_extends.apply(this, arguments); }

var SvgReactQuery = function SvgReactQuery(props) {
  return /*#__PURE__*/react.createElement("svg", react_query_extends({
    viewBox: "0 0 256 230",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), react_query_path || (react_query_path = /*#__PURE__*/react.createElement("path", {
    d: "m157.98 142.487-4.91 8.527a8.288 8.288 0 0 1-7.182 4.151H108.27a8.288 8.288 0 0 1-7.182-4.151l-4.911-8.527h61.802Zm13.747-23.87-8.658 15.034h-71.98l-8.658-15.034h89.296Zm-8.34-23.342 8.354 14.506H82.417l8.354-14.506h72.616Zm-17.5-22.066a8.288 8.288 0 0 1 7.183 4.151l5.228 9.079H95.86l5.229-9.079a8.288 8.288 0 0 1 7.182-4.151h37.617Z",
    fill: "currentColor",
    opacity: 0.2
  })), react_query_path2 || (react_query_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M53.523 69.252c-4.167-20.206-5.062-35.704-2.368-46.957 1.602-6.693 4.53-12.153 8.984-16.093 4.702-4.159 10.646-6.2 17.326-6.2 11.018 0 22.602 5.025 34.98 14.57 5.05 3.894 10.29 8.587 15.732 14.082.434-.557.923-1.083 1.469-1.57 15.386-13.71 28.34-22.23 39.42-25.514 6.588-1.954 12.773-2.14 18.405-.244 5.946 2 10.683 6.137 14.026 11.93 5.516 9.561 6.97 22.124 4.914 37.637-.838 6.323-2.271 13.21-4.296 20.673.764.092 1.53.262 2.288.513 19.521 6.47 33.345 13.426 41.714 21.377 4.98 4.73 8.231 9.996 9.407 15.826 1.24 6.153.03 12.324-3.308 18.113-5.506 9.548-15.63 17.077-30.052 23.041-5.79 2.395-12.343 4.564-19.664 6.515.334.754.594 1.555.767 2.395 4.167 20.206 5.061 35.704 2.368 46.957-1.602 6.693-4.531 12.153-8.985 16.093-4.701 4.159-10.646 6.2-17.325 6.2-11.019 0-22.602-5.025-34.98-14.57-5.104-3.936-10.402-8.687-15.907-14.258a11.737 11.737 0 0 1-2.084 2.442c-15.386 13.712-28.34 22.23-39.42 25.515-6.588 1.954-12.773 2.14-18.405.244-5.946-2-10.683-6.137-14.026-11.93-5.516-9.561-6.97-22.124-4.914-37.637.869-6.551 2.376-13.709 4.518-21.485a11.732 11.732 0 0 1-2.51-.537c-19.521-6.47-33.345-13.426-41.714-21.377-4.98-4.73-8.231-9.996-9.407-15.826-1.24-6.153-.03-12.325 3.308-18.114 5.506-9.547 15.63-17.077 30.052-23.04 5.963-2.467 12.734-4.693 20.32-6.689a11.81 11.81 0 0 1-.633-2.082Z",
    fill: "currentColor",
    opacity: 0.2
  })), react_query_path3 || (react_query_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M189.647 161.333a3.684 3.684 0 0 1 4.235 2.81l.023.112.207 1.075c6.71 35.276 1.983 52.915-14.18 52.915-15.813 0-35.944-15.051-60.392-45.153a3.684 3.684 0 0 1 2.777-6.005h.114l1.288.009c10.288.056 20.289-.303 30.004-1.076 11.467-.913 23.442-2.475 35.924-4.687ZM78.646 134.667l.062.105.646 1.127c5.177 9 10.57 17.542 16.18 25.627 6.608 9.52 14.038 19.158 22.29 28.914a3.684 3.684 0 0 1-.309 5.082l-.093.083-.83.715c-27.307 23.397-45.055 28.068-53.244 14.012-8.017-13.757-5.11-38.773 8.719-75.047a3.683 3.683 0 0 1 6.579-.618Zm124.857-52.054.112.037 1.028.354c33.705 11.725 46.51 24.61 38.416 38.655-7.916 13.736-30.93 23.738-69.041 30.004a3.683 3.683 0 0 1-3.773-5.501c5.458-9.286 10.375-18.524 14.749-27.717 4.96-10.425 9.615-21.616 13.965-33.57a3.684 3.684 0 0 1 4.432-2.295l.112.033ZM84.446 76.71a3.683 3.683 0 0 1 1.31 5.042c-5.46 9.285-10.376 18.524-14.75 27.717-4.96 10.425-9.615 21.615-13.965 33.57a3.684 3.684 0 0 1-4.544 2.262l-.112-.037-1.028-.355c-33.705-11.724-46.51-24.61-38.416-38.654 7.916-13.737 30.93-23.738 69.041-30.004.85-.14 1.722.022 2.464.459Zm108.206-57.748c8.017 13.758 5.11 38.774-8.719 75.048a3.683 3.683 0 0 1-6.579.618l-.062-.105-.646-1.127c-5.177-9-10.57-17.542-16.18-25.627-6.608-9.52-14.038-19.158-22.29-28.914a3.684 3.684 0 0 1 .309-5.082l.093-.083.83-.715c27.307-23.397 45.055-28.068 53.244-14.013ZM77.45 10.59c15.814 0 35.945 15.05 60.392 45.152a3.684 3.684 0 0 1-2.777 6.005h-.114l-1.288-.008c-10.287-.056-20.289.303-30.003 1.076-11.468.913-23.443 2.475-35.925 4.687a3.684 3.684 0 0 1-4.234-2.81l-.024-.113-.207-1.074C56.56 28.228 61.286 10.59 77.45 10.59Z",
    fill: "currentColor"
  })), react_query_path4 || (react_query_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M111.295 73.67h31.575c4.618 0 8.883 2.469 11.182 6.474l15.855 27.626a12.892 12.892 0 0 1 0 12.834l-15.855 27.626a12.892 12.892 0 0 1-11.182 6.475h-31.575c-4.618 0-8.883-2.47-11.182-6.475l-15.855-27.626a12.892 12.892 0 0 1 0-12.834l15.855-27.626a12.892 12.892 0 0 1 11.182-6.475Zm26.763 8.337c4.62 0 8.887 2.473 11.185 6.481l11.056 19.288a12.892 12.892 0 0 1 0 12.822l-11.056 19.288a12.892 12.892 0 0 1-11.185 6.48h-21.951c-4.62 0-8.887-2.472-11.185-6.48l-11.056-19.288a12.892 12.892 0 0 1 0-12.822l11.056-19.288a12.892 12.892 0 0 1 11.185-6.48h21.951Zm-5.187 9.12h-11.577a12.892 12.892 0 0 0-11.178 6.47l-5.842 10.167a12.892 12.892 0 0 0 0 12.846l5.842 10.168a12.892 12.892 0 0 0 11.178 6.47h11.577c4.615 0 8.879-2.468 11.178-6.47l5.842-10.168a12.892 12.892 0 0 0 0-12.846l-5.842-10.168a12.892 12.892 0 0 0-11.178-6.469Zm-4.995 8.729c4.612 0 8.873 2.464 11.174 6.46l.828 1.44a12.892 12.892 0 0 1 0 12.862l-.828 1.44a12.892 12.892 0 0 1-11.174 6.46h-1.587a12.892 12.892 0 0 1-11.174-6.46l-.828-1.44a12.892 12.892 0 0 1 0-12.862l.828-1.44a12.892 12.892 0 0 1 11.174-6.46h1.587Zm-.791 8.599a5.738 5.738 0 0 0-4.971 2.866 5.729 5.729 0 0 0 0 5.732 5.738 5.738 0 0 0 9.937 0 5.729 5.729 0 0 0 0-5.732 5.736 5.736 0 0 0-4.966-2.866Zm-46.51 5.732h10.321",
    fill: "transparent"
  })));
};
/* harmony default export */ var react_query = (SvgReactQuery);
;// CONCATENATED MODULE: ./public/icons/tech-logos/remix.svg
var remix_path;
function remix_extends() { remix_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return remix_extends.apply(this, arguments); }

var SvgRemix = function SvgRemix(props) {
  return /*#__PURE__*/react.createElement("svg", remix_extends({
    viewBox: "0 0 256 297",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), remix_path || (remix_path = /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    d: "M141.675 0C218.047 0 256 36.35 256 94.414c0 43.43-26.707 71.753-62.785 76.474 30.455 6.137 48.259 23.604 51.54 58.065l.474 6.337.415 5.924.358 5.542.249 4.179.267 4.93.138 2.814.198 4.47.159 4.222.079 2.427.107 3.888.092 4.446.033 2.148.06 6.226.02 6.496v3.885h-78.758l.004-1.62.028-3.147.047-3.065.136-7.424.035-2.489.027-3.902-.004-2.496-.023-2.617-.032-2.054-.064-2.876-.094-3.05-.125-3.242-.16-3.455-.096-1.813-.16-2.833-.186-2.976-.287-4.204-.247-3.342a116.56 116.56 0 0 0-.247-3.02l-.202-1.934c-2.6-22.827-11.655-32.157-27.163-35.269l-1.307-.245a60.184 60.184 0 0 0-2.704-.408l-1.397-.164c-.236-.025-.472-.05-.71-.073l-1.442-.127-1.471-.103-1.502-.081-1.514-.058-1.544-.039-1.574-.018L0 198.74V136.9h127.62c2.086 0 4.108-.04 6.066-.12l1.936-.095 1.893-.122 1.85-.15c.305-.028.608-.056.909-.086l1.785-.193a86.3 86.3 0 0 0 3.442-.475l1.657-.28c20.709-3.755 31.063-14.749 31.063-36.2 0-24.075-16.867-38.666-50.602-38.666H0V0h141.675ZM83.276 250.785c10.333 0 14.657 5.738 16.197 11.23l.203.79.167.782.109.617.046.306.078.603.058.59.023.29.031.569.01.278.008.54v29.507H0v-46.102h83.276Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ var remix = (SvgRemix);
;// CONCATENATED MODULE: ./public/icons/tech-logos/sendgrid.svg
var sendgrid_path, sendgrid_path2, sendgrid_path3, sendgrid_path4, _path5;
function sendgrid_extends() { sendgrid_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sendgrid_extends.apply(this, arguments); }

var SvgSendgrid = function SvgSendgrid(props) {
  return /*#__PURE__*/react.createElement("svg", sendgrid_extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), sendgrid_path || (sendgrid_path = /*#__PURE__*/react.createElement("path", {
    d: "M256 0v170.667h-85.333v85.33H.002v-85.331H0V85.332h85.333V0H256Z",
    fill: "#9DD6E3"
  })), sendgrid_path2 || (sendgrid_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#3F72AB",
    d: "M.002 255.996h85.333v-85.333H.002z"
  })), sendgrid_path3 || (sendgrid_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#00A9D1",
    d: "M170.667 170.667H256V85.33h-85.333zM85.333 85.333h85.334V0H85.333z"
  })), sendgrid_path4 || (sendgrid_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#2191C4",
    d: "M85.333 170.665h85.334V85.33H85.333z"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    fill: "#3F72AB",
    d: "M170.667 85.333H256V0h-85.333z"
  })));
};
/* harmony default export */ var sendgrid = (SvgSendgrid);
;// CONCATENATED MODULE: ./public/icons/tech-logos/stylelint.svg
var stylelint_path;
function stylelint_extends() { stylelint_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stylelint_extends.apply(this, arguments); }

var SvgStylelint = function SvgStylelint(props) {
  return /*#__PURE__*/react.createElement("svg", stylelint_extends({
    viewBox: "0 0 256 245",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), stylelint_path || (stylelint_path = /*#__PURE__*/react.createElement("path", {
    d: "M129.74 243.648c28-100.109 27.188-100.563 47.425-171.942l4.864 2.816c2.65 1.516 4.813.268 4.813-2.778V37.696C192.218 18.893 196.416 4.352 197.658 0h21.92L256 33.728 232.077 54.4l18.093 19.565-119.226 169.683c-.576.96-1.389.742-1.203 0Zm13.025-215.782c1.088 0 1.958.595 1.958 1.344v17.44c0 .73-.877 1.324-1.958 1.324h-29.44c-1.088 0-1.965-.595-1.965-1.33V29.196c0-.736.877-1.344 1.958-1.344h29.44l.007.013ZM179.117 8.55 146.72 27.251c.371.576.602 1.235.602 1.952v17.453c0 .896-.359 1.715-.935 2.368l32.723 18.893c2.228 1.293 4.058.237 4.058-2.336V10.893c0-2.58-1.818-3.629-4.051-2.343Zm-70.362 38.106v-17.46c0-.716.23-1.375.602-1.945L76.96 8.538c-2.227-1.28-4.058-.23-4.058 2.342v54.688c0 2.573 1.83 3.629 4.064 2.336l32.717-18.893c-.576-.659-.921-1.472-.921-2.368l-.007.013Zm16.301 196.992h1.203C98.266 143.539 99.072 143.085 78.835 71.706l-4.864 2.816c-2.643 1.516-4.813.268-4.813-2.778V37.696C63.782 18.899 59.584 4.352 58.342 0H36.43L0 33.728 23.917 54.4 5.824 73.971l119.232 169.677ZM127.11 84.41a8.845 8.845 0 1 0 0-17.69 8.845 8.845 0 0 0 0 17.69Zm0 52.576a8.845 8.845 0 1 0 0-17.69 8.845 8.845 0 0 0 0 17.69Zm0 52.588a8.845 8.845 0 1 0 0-17.69 8.845 8.845 0 0 0 0 17.69Z"
  })));
};
/* harmony default export */ var stylelint = (SvgStylelint);
;// CONCATENATED MODULE: ./public/icons/tech-logos/swc.svg
var swc_defs, swc_path, swc_path2;
function swc_extends() { swc_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return swc_extends.apply(this, arguments); }

var SvgSwc = function SvgSwc(props) {
  return /*#__PURE__*/react.createElement("svg", swc_extends({
    viewBox: "0 0 512 180",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), swc_defs || (swc_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    x1: "0%",
    y1: "50.015%",
    x2: "100.005%",
    y2: "50.015%",
    id: "swc_svg__a"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#FFA588",
    offset: "0%"
  }), /*#__PURE__*/react.createElement("stop", {
    stopColor: "#FCB371",
    offset: "27.1%"
  }), /*#__PURE__*/react.createElement("stop", {
    stopColor: "#F4D837",
    offset: "83.57%"
  }), /*#__PURE__*/react.createElement("stop", {
    stopColor: "#F1E425",
    offset: "100%"
  })))), swc_path || (swc_path = /*#__PURE__*/react.createElement("path", {
    d: "M460.924 179.246c-13.762 0-26.733-5.378-36.488-15.133L348.453 88.13c-7.646-7.646-12.655-17.19-14.448-27.577a51.101 51.101 0 0 1 .158-18.35h-22.462c-5.484 0-7.804 3.638-8.7 5.8-.897 2.162-1.846 6.38 2.056 10.282l32.85 32.85c7.646 7.646 12.655 17.19 14.448 27.578 1.687 9.597.527 19.51-3.217 28.685-3.796 9.122-10.018 16.926-17.98 22.568-8.648 6.064-18.877 9.28-29.687 9.28h-1.054c-13.763 0-26.734-5.378-36.489-15.133l-7.277-7.277c-3.48 5.115-7.803 9.544-12.865 13.077-8.648 6.064-18.877 9.28-29.687 9.28-13.762 0-26.734-5.378-36.489-15.133L58.443 44.892a9.334 9.334 0 0 0-6.644-2.742c-5.484 0-7.804 3.639-8.7 5.8-.897 2.162-1.846 6.38 2.056 10.283l32.85 32.85c7.646 7.646 12.655 17.19 14.448 27.577 1.687 9.597.527 19.51-3.217 28.685-3.796 9.122-10.018 16.926-17.98 22.568-8.648 6.064-18.877 9.28-29.687 9.28H26.541c-11.653 0-21.091-9.438-21.091-21.091s9.438-21.092 21.091-21.092h14.817c5.484 0 7.804-3.638 8.7-5.8.897-2.162 1.846-6.38-2.056-10.282L15.205 88.13C7.559 80.484 2.55 70.94.757 60.553-.93 50.956.23 41.043 3.973 31.868 7.77 22.746 13.992 14.942 21.954 9.3 30.602 3.236 40.884.02 51.694.02c13.762 0 26.733 5.378 36.488 15.133L207.35 134.321a9.334 9.334 0 0 0 6.644 2.742c5.483 0 7.804-3.638 8.7-5.8.896-2.162 1.845-6.38-2.004-10.23l-85-85c-8.225-8.225-8.225-21.565 0-29.844 8.227-8.278 21.567-8.226 29.846 0l84.946 84.947.106.105 43.08 43.08a9.334 9.334 0 0 0 6.643 2.742h1.055c5.484 0 7.804-3.638 8.7-5.8.896-2.162 1.846-6.38-2.056-10.283l-32.798-32.85c-7.646-7.646-12.655-17.19-14.448-27.577-1.687-9.597-.527-19.51 3.217-28.685 3.796-9.122 10.018-16.926 17.98-22.568 8.648-6.064 18.93-9.28 29.74-9.28h85.895c11.654 0 21.092 9.438 21.092 21.091 0 11.654-9.438 21.092-21.092 21.092h-12.655c-5.483 0-7.803 3.638-8.7 5.8-.896 2.162-1.845 6.38 2.057 10.282l75.982 75.983a9.334 9.334 0 0 0 6.644 2.742c4.799 0 8.7-3.902 8.7-8.7 0-11.653 9.439-21.092 21.092-21.092 11.653 0 21.092 9.439 21.092 21.092.053 28.104-22.832 50.936-50.884 50.936Z",
    fill: "url(#swc_svg__a)"
  })), swc_path2 || (swc_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M460.924 160.791c-8.858 0-17.19-3.427-23.464-9.702l-75.983-75.983c-9.65-9.65-12.391-23.517-7.171-36.12 2.689-6.432 7.066-11.653 12.497-15.185H311.7c-11.495 0-21.356 6.59-25.785 17.19-4.43 10.598-2.056 22.251 6.064 30.371l32.85 32.85c9.65 9.65 12.392 23.518 7.171 36.12-5.22 12.602-16.978 20.459-30.635 20.459h-1.055c-8.858 0-17.19-3.427-23.464-9.702l-30.32-30.32c1.371 6.38.739 13.13-1.898 19.563-5.22 12.602-16.979 20.459-30.635 20.459-8.859 0-17.19-3.427-23.465-9.702L71.361 31.92c-5.273-5.273-12.286-8.173-19.72-8.173-11.495 0-21.356 6.591-25.785 17.19C21.479 51.536 23.8 63.189 31.92 71.31l32.85 32.85c9.65 9.65 12.391 23.517 7.171 36.12-5.22 12.602-16.979 20.458-30.635 20.458H26.54a2.61 2.61 0 0 1-2.636-2.636 2.61 2.61 0 0 1 2.636-2.637h14.817c11.495 0 21.356-6.59 25.785-17.19 4.43-10.598 2.056-22.251-6.064-30.371l-32.85-32.85c-9.65-9.597-12.392-23.465-7.171-36.067 5.22-12.655 16.926-20.512 30.635-20.512 8.859 0 17.19 3.427 23.465 9.702l119.168 119.168c5.273 5.273 12.286 8.173 19.72 8.173 11.495 0 21.356-6.591 25.785-17.19 4.376-10.598 2.109-22.199-6.011-30.319l-85.052-85a2.61 2.61 0 0 1 0-3.743 2.61 2.61 0 0 1 3.743 0l84.947 84.947.053.052 43.08 43.08c5.272 5.273 12.285 8.173 19.72 8.173h1.055c11.495 0 21.355-6.591 25.784-17.19 4.377-10.598 2.057-22.251-6.064-30.372l-32.85-32.85c-9.65-9.65-12.391-23.517-7.17-36.12 5.22-12.602 16.978-20.458 30.635-20.458h85.895a2.61 2.61 0 0 1 2.637 2.636 2.61 2.61 0 0 1-2.637 2.637h-12.655c-11.494 0-21.355 6.59-25.784 17.19-4.377 10.598-2.057 22.251 6.064 30.371l75.982 75.983c5.273 5.273 12.286 8.173 19.721 8.173 14.975 0 27.156-12.18 27.156-27.155a2.61 2.61 0 0 1 2.636-2.637 2.611 2.611 0 0 1 2.637 2.637c.052 17.875-14.5 32.428-32.429 32.428Z",
    fill: "#FFF"
  })));
};
/* harmony default export */ var swc = (SvgSwc);
;// CONCATENATED MODULE: ./public/icons/tech-logos/takealot.svg
var takealot_defs, _g;
function takealot_extends() { takealot_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return takealot_extends.apply(this, arguments); }

var SvgTakealot = function SvgTakealot(props) {
  return /*#__PURE__*/react.createElement("svg", takealot_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 29
  }, props), takealot_defs || (takealot_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("path", {
    id: "takealot_svg__a",
    d: "M0 .03h139.84V28.4H0z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "takealot_svg__c",
    d: "M0 .03h139.84V28.4H0z"
  }))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M132.16 26.8c-6.99 3.6-15.59.9-19.22-6.05a14.15 14.15 0 0 1 6.08-19.12c6.99-3.61 15.59-.9 19.22 6.05 3.62 6.95.9 15.51-6.08 19.12z",
    fill: "#0B79BF"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m118.58 14.98 1.23.13a2.93 2.93 0 0 1-.92 1.74c-.45.38-1 .57-1.64.57-.87 0-1.54-.32-2.01-.95-.47-.63-.7-1.4-.7-2.32 0-.95.25-1.73.77-2.34.5-.62 1.19-.93 2.04-.93 1.38 0 2.2.72 2.46 2.16l-1.23.17c-.1-.78-.49-1.17-1.15-1.17-.48 0-.83.21-1.05.63-.22.42-.33.93-.33 1.53 0 .63.11 1.12.34 1.47.23.34.54.51.95.51.63 0 1.04-.4 1.24-1.2m4.87 1.27c.96 0 1.43-.71 1.43-2.13 0-.64-.11-1.15-.34-1.52a1.15 1.15 0 0 0-1.05-.56c-.5 0-.86.2-1.1.58-.23.38-.35.89-.35 1.52 0 .69.12 1.2.37 1.57.26.36.6.54 1.04.54m-.05 1.17c-.93 0-1.65-.33-2.14-1a3.77 3.77 0 0 1-.73-2.3c0-.92.27-1.7.81-2.31a2.73 2.73 0 0 1 2.15-.93c.85 0 1.54.3 2.09.9.54.6.81 1.38.81 2.34 0 1-.28 1.8-.85 2.4-.56.6-1.28.9-2.14.9m13.24-.13h-1.5v-3.91c0-.81-.35-1.22-1.08-1.22-.42 0-.75.15-1 .46-.26.3-.38.76-.38 1.37v3.3h-1.52v-3.91c0-.83-.34-1.24-1.01-1.24-.42 0-.76.17-1.04.5-.28.33-.42.78-.42 1.35v3.3h-1.47V11h1.38v1.34c.45-.98 1.15-1.47 2.1-1.47.93 0 1.53.49 1.81 1.47.51-.98 1.21-1.47 2.1-1.47.62 0 1.1.19 1.48.56.37.38.55.85.55 1.41v4.44z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m104.78 2.54-.01 6.23h2.95v3.8h-2.94v6.58c0 .7.06 1.16.17 1.39.18.35.49.52.92.52.4 0 .95-.13 1.66-.4l1.28 4.1c-1.32.34-3.44.73-4.6.73-1.32 0-2.3-.2-2.93-.6-.63-.4-1.1-1-1.4-1.82-.3-.81-.45-2.13-.45-3.96v-6.54h-1.98v-3.8h1.97V2.55l5.36-.01z",
    fill: "#4C4C4E"
  }), /*#__PURE__*/react.createElement("mask", {
    id: "takealot_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#takealot_svg__a"
  })), /*#__PURE__*/react.createElement("path", {
    d: "M7.32 2.55v6.22h2.95v3.8H7.33v6.58c0 .7.06 1.16.18 1.39.17.35.48.52.91.52.4 0 .95-.13 1.66-.4l1.28 4.1a23.5 23.5 0 0 1-4.59.73c-1.33 0-2.31-.2-2.94-.6-.63-.4-1.1-1-1.4-1.82-.3-.81-.45-2.13-.45-3.96v-6.54H0v-3.8h1.97V2.55h5.35z",
    fill: "#4C4C4E",
    mask: "url(#takealot_svg__b)"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M21.76 17.39c-.74.3-1.5.58-2.3.81-1.09.34-1.77.68-2.06 1-.3.35-.45.73-.45 1.16 0 .5.15.9.44 1.21.3.31.73.47 1.3.47.6 0 1.15-.17 1.66-.51.51-.34.87-.75 1.09-1.24.21-.49.32-1.12.32-1.9v-1zm.89 7.75c-.2-.42-.34-.74-.4-.96a8.23 8.23 0 0 1-.18-1.04 7 7 0 0 1-2.1 1.7c-.94.45-2.03.68-3.29.68-1.66 0-2.92-.45-3.79-1.35a4.65 4.65 0 0 1-1.3-3.34c0-1.24.31-2.26.93-3.06.62-.8 1.77-1.4 3.44-1.8 2-.47 3.33-.8 3.93-.96.9-.24 1.41-.27 1.8-.88.42-.65-.04-1.25-.33-1.52-.3-.28-.77-.46-1.45-.46-.87 0-1.44.1-1.87.45-.75.6-.5 1.48-1.24 1.48l-4.8.01c.2-1.04.24-2.16.84-3.1.38-.58.88-1.11 1.56-1.56a5.88 5.88 0 0 1 2.03-.74 18.95 18.95 0 0 1 6.64.05c.97.2 1.78.65 2.43 1.31.46.46.82 1.12 1.08 1.96.27.85.4 1.66.4 2.43v10.7h-4.33zm46.79-7.75c-.73.3-1.5.58-2.3.81-1.08.34-1.77.68-2.06 1-.3.35-.44.73-.44 1.16 0 .5.15.9.44 1.21.3.31.73.47 1.3.47.59 0 1.14-.17 1.66-.51.5-.34.87-.75 1.08-1.24.22-.49.32-1.12.32-1.9v-1zm.9 7.75c-.2-.42-.34-.74-.4-.96a8.1 8.1 0 0 1-.19-1.04 7 7 0 0 1-2.09 1.7c-.94.45-2.04.68-3.29.68-1.66 0-2.93-.45-3.79-1.35a4.65 4.65 0 0 1-1.3-3.34c0-1.24.3-2.26.93-3.06.62-.8 1.77-1.4 3.44-1.8 2-.47 3.33-.8 3.93-.96.89-.24 1.4-.27 1.8-.88.42-.65-.05-1.25-.34-1.52-.3-.28-.76-.46-1.44-.46-.88 0-1.45.1-1.87.45-.75.6-.5 1.48-1.24 1.48l-4.8.01c.2-1.04.24-2.16.83-3.1.38-.58.89-1.11 1.57-1.56a5.88 5.88 0 0 1 2.02-.74 18.96 18.96 0 0 1 6.65.05c.97.2 1.78.65 2.43 1.31.45.46.81 1.12 1.08 1.96.26.85.4 1.66.4 2.43v10.7h-4.33zM27.99 2.55h4.69v12.94l6.07-6.71h5.57l-5.6 6.04 5.54 10.33h-5.5l-3.42-6.84-2.78 3.03v3.81h-4.57z",
    fill: "#4C4C4E"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M53.26 15.3c-.1-1.2-.38-1.85-.83-2.38a2.24 2.24 0 0 0-1.78-.78c-.85 0-1.53.4-2.04 1.18-.32.5-.53 1.01-.61 1.98h5.26zm5.23 5.19a6.4 6.4 0 0 1-3 3.96c-1.14.71-2.78 1.07-4.9 1.07-1.85 0-3.3-.3-4.37-.92a6.95 6.95 0 0 1-2.63-2.9 9.97 9.97 0 0 1-1.04-4.7c0-2.55.7-4.62 2.1-6.2 1.39-1.58 3.32-2.37 5.78-2.37 2 0 3.57.35 4.72 1.06a6.73 6.73 0 0 1 2.65 3.08c.6 1.35.9 3.1.9 5.25v.7H47.98c.1 1.01.33 1.76.7 2.26.52.7 1.09 1.23 1.92 1.22 1.87-.01 2.58-.73 2.91-1.73l4.98.22z",
    fill: "#4C4C4E"
  }), /*#__PURE__*/react.createElement("mask", {
    id: "takealot_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#takealot_svg__c"
  })), /*#__PURE__*/react.createElement("path", {
    fill: "#4C4C4E",
    mask: "url(#takealot_svg__d)",
    d: "M75.69 2.54h4.84v22.55h-4.84zM86.92 17c0 1.46.25 3.42.75 4.12a2.25 2.25 0 0 0 3.8.02c.49-.69.74-2.68.74-4.2 0-1.41-.25-2.84-.75-3.54-.5-.69-1.12-1.04-1.85-1.04a2.3 2.3 0 0 0-1.93 1.06c-.51.7-.76 2.15-.76 3.58m-5.36.02c0-2.5.71-4.55 2.15-6.17a7.39 7.39 0 0 1 5.82-2.42c2.8 0 4.9.95 6.33 2.85a9.15 9.15 0 0 1 1.72 5.65c0 2.51-.71 4.57-2.13 6.18-1.43 1.6-3.4 2.4-5.9 2.4a7.5 7.5 0 0 1-5.45-2c-1.7-1.65-2.54-3.81-2.54-6.49"
  }))));
};
/* harmony default export */ var takealot = (SvgTakealot);
;// CONCATENATED MODULE: ./public/icons/tech-logos/trpc.svg
var trpc_path;
function trpc_extends() { trpc_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return trpc_extends.apply(this, arguments); }

var SvgTrpc = function SvgTrpc(props) {
  return /*#__PURE__*/react.createElement("svg", trpc_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "none"
  }, props), trpc_path || (trpc_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m255.446 75 71.077 41.008v22.548l86.031 49.682v84.986l23.077 13.322v82.062L364.6 409.615l-31.535-18.237-76.673 44.268-76.214-44.012-31.093 17.981-71.031-41.077v-81.992l22.177-12.803v-85.505l84.184-48.6.047-.002v-23.628L255.446 75Zm71.077 84.879v38.144l-71.031 41.008-71.03-41.008v-37.087l-.047.002-65.723 37.962v64.184l30.393-17.546 71.03 41.008v81.992l-21.489 12.427 57.766 33.358 58.226-33.611-21.049-12.174v-81.992l71.031-41.008 29.492 17.027V198.9l-67.569-39.021Zm-14.492 198.09v-50.054l43.338 25.016v50.054l-43.338-25.016Zm105.138-50.123-43.338 25.016v50.123l43.338-25.085v-50.054ZM96.515 357.9v-50.054l43.339 25.016v50.053L96.515 357.9Zm105.139-50.054-43.339 25.016v50.053l43.339-25.015v-50.054Zm119.608-15.923 43.338-25.015 43.338 25.015-43.338 25.039-43.338-25.039Zm-172.177-25.085-43.339 25.085 43.339 24.969 43.338-24.969-43.338-25.085Zm53.838-79.476v-50.054l43.292 25.038v50.031l-43.292-25.015Zm105.092-50.054-43.292 25.038v50.008l43.292-24.992v-50.054Zm-95.861-15.97 43.292-25.015 43.339 25.015-43.339 25.016-43.292-25.016Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ var trpc = (SvgTrpc);
;// CONCATENATED MODULE: ./public/icons/tech-logos/turborepo.svg
var turborepo_g;
function turborepo_extends() { turborepo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return turborepo_extends.apply(this, arguments); }

var SvgTurborepo = function SvgTurborepo(props) {
  return /*#__PURE__*/react.createElement("svg", turborepo_extends({
    viewBox: "0 0 256 318",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), turborepo_g || (turborepo_g = /*#__PURE__*/react.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M103.41.095C66.837-1.166 30.268 10.183 0 34.144l20.177 11.35c23.962-17.656 54.226-25.222 83.233-23.961V.095Z",
    opacity: 0.4
  }), /*#__PURE__*/react.createElement("path", {
    d: "M210.6 48.016c-25.222-26.483-58.01-42.877-93.319-46.66v21.438c30.268 5.044 56.75 18.916 78.188 40.355L210.6 48.016Z",
    opacity: 0.5
  }), /*#__PURE__*/react.createElement("path", {
    d: "M256 151.424c-1.26-32.788-13.871-65.576-35.309-93.32l-15.136 15.133c17.657 23.96 27.747 50.444 29.008 78.187H256Z",
    opacity: 0.6
  }), /*#__PURE__*/react.createElement("path", {
    d: "M220.691 259.877c21.438-27.744 34.049-60.532 35.309-93.32h-21.437c-1.26 27.744-11.351 54.227-29.008 78.187l15.136 15.133Z",
    opacity: 0.7
  }), /*#__PURE__*/react.createElement("path", {
    d: "M117.281 316.626c34.049-3.783 68.097-20.178 93.32-46.66l-15.132-15.133c-21.437 22.7-49.185 36.571-78.188 40.354v21.439Z",
    opacity: 0.8
  }), /*#__PURE__*/react.createElement("path", {
    d: "M0 283.838c30.268 23.96 66.837 35.31 103.41 34.049v-21.439c-29.007 1.262-58.01-6.305-83.233-23.96L0 283.838Z",
    opacity: 0.9
  }), /*#__PURE__*/react.createElement("path", {
    d: "M97.651 71.344c13.479 0 25.919 2.295 37.321 6.886 11.402 4.443 21.177 10.663 29.324 18.66 8.292 7.998 14.734 17.402 19.326 28.214 4.593 10.663 6.887 22.214 6.887 34.655 0 12.44-2.294 24.066-6.887 34.877-4.592 10.663-11.034 19.993-19.326 27.99-8.147 7.998-17.922 14.292-29.324 18.883-11.402 4.443-23.842 6.665-37.32 6.665-13.625 0-26.142-2.222-37.544-6.665-11.257-4.591-20.954-10.885-29.101-18.882-8.147-7.998-14.513-17.328-19.105-27.991-4.592-10.811-6.887-22.437-6.887-34.877 0-12.44 2.295-23.992 6.887-34.655 4.592-10.812 10.958-20.216 19.105-28.213 8.147-7.998 17.844-14.218 29.101-18.66 11.402-4.592 23.92-6.887 37.543-6.887Zm0 42.208c-6.37 0-12.44 1.184-18.216 3.554-5.626 2.222-10.59 5.406-14.884 9.553-4.293 4.146-7.702 9.034-10.219 14.661-2.516 5.628-3.776 11.774-3.776 18.439 0 6.664 1.26 12.81 3.776 18.438 2.517 5.628 5.926 10.515 10.22 14.662 4.293 4.147 9.257 7.404 14.883 9.774 5.776 2.222 11.846 3.332 18.216 3.332 6.37 0 12.368-1.11 17.994-3.332 5.776-2.37 10.813-5.627 15.106-9.774 4.443-4.147 7.925-9.034 10.441-14.662 2.516-5.628 3.777-11.774 3.777-18.438 0-6.665-1.26-12.811-3.777-18.439-2.516-5.627-5.998-10.515-10.44-14.661-4.294-4.147-9.331-7.331-15.107-9.553-5.626-2.37-11.624-3.554-17.994-3.554Z"
  }))));
};
/* harmony default export */ var turborepo = (SvgTurborepo);
;// CONCATENATED MODULE: ./public/icons/tech-logos/vend_pos.svg
var _style, vend_pos_path, vend_pos_path2, vend_pos_path3;
function vend_pos_extends() { vend_pos_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return vend_pos_extends.apply(this, arguments); }

var SvgVendPos = function SvgVendPos(props) {
  return /*#__PURE__*/react.createElement("svg", vend_pos_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240.14 176.35",
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 240.14 176.35"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/react.createElement("style", null, ".vend_pos_svg__st1{fill:currentColor}")), /*#__PURE__*/react.createElement("path", {
    d: "m230.1 68.14-23.27-39.01a9.353 9.353 0 0 0-8.31-5.06H21.38c-5.17-.02-9.37 4.16-9.38 9.33v78.11c.03 5.16 4.23 9.31 9.38 9.3h177.13c3.5 0 6.71-1.95 8.31-5.06l23.28-38.99a9.43 9.43 0 0 0 0-8.62z",
    style: {
      fill: "#ffffffff"
    }
  }), vend_pos_path || (vend_pos_path = /*#__PURE__*/react.createElement("path", {
    className: "vend_pos_svg__st1",
    d: "m239 68.39-25.5-42.75a10.245 10.245 0 0 0-9.11-5.55H10.28C4.62 20.08.02 24.65 0 30.31v85.59c.03 5.65 4.63 10.21 10.28 10.19h194.1c3.84 0 7.35-2.14 9.11-5.55L239 77.81a10.3 10.3 0 0 0 0-9.42zm-180.54-5-19.68 40.28c-.21.51-.79.75-1.3.55-.25-.1-.44-.3-.55-.55L17.17 63.4a.6.6 0 0 1 .26-.81c.11-.06.24-.08.36-.06h7.58c.26 0 .51 0 .62.27l11.87 25.66L49.65 62.8c.12-.22.37-.34.62-.3h7.57a.6.6 0 0 1 .65.52c.01.11-.01.22-.06.33l.03.04zm41.37 18.7-.06 1.76c-.03.35-.34.61-.69.59h-30.9a14.21 14.21 0 0 0 3.43 9.9 12.17 12.17 0 0 0 9.5 4.13c4.91 0 9.69-3.19 12.16-7.38.19-.32.61-.43.93-.24l5.11 3c.33.19.44.61.25.94-4.57 7.13-11.03 10.7-19.36 10.71-5.68.19-11.13-2.25-14.77-6.62-3.66-4.29-5.49-10.05-5.49-17.28.04-2.77.61-5.5 1.66-8.06 1.75-4.87 5.46-8.79 10.23-10.8 2.64-1.11 5.48-1.67 8.35-1.65 8.75 0 14.65 3.69 17.69 11.06 1.36 3.14 2.03 6.53 1.96 9.94zM143 103.37c0 .38-.58.86-1 .86h-6.67c-.38 0-.6-.48-.6-.86V78.84c0-3.58-.67-6.18-1.92-7.8-1.42-1.88-4-2.82-7.45-2.82-6.89 0-10.47 4.34-10.47 13v22.18c0 .37-.06.85-.44.85h-6.61c-.38 0-.47-.48-.47-.85V62.91c0-.38.09-.41.47-.41h6.65c.37 0 .44 0 .44.41v5.28c3.42-4.73 7.85-7.11 13.4-7.11 9.73.01 14.67 6.01 14.67 17.89v24.4zm49.26 0c0 .38-.31.86-.69.86h-6.65c-.45-.07-.8-.41-.88-.86v-6.1c-3.42 5.49-8.29 8.23-14.19 8.23-6.56 0-11.64-2.46-15.32-7.36a23.61 23.61 0 0 1-4.86-14.58c-.05-3.94.79-7.84 2.45-11.41 1.65-3.58 4.38-6.55 7.81-8.49 2.93-1.68 6.26-2.57 9.64-2.57 2.96.02 5.85.82 8.4 2.32 2.55 1.41 4.63 3.53 6 6.1V41.19c0-.38.51-.58.88-.58h6.65c.38 0 .69.2.69.58l.07 62.18zm25.65-25.13a5.139 5.139 0 0 1-5.19-5.09c-.03-2.84 2.25-5.16 5.09-5.19s5.16 2.25 5.19 5.09v.04c.01 2.83-2.29 5.14-5.12 5.15h.03z"
  })), vend_pos_path2 || (vend_pos_path2 = /*#__PURE__*/react.createElement("path", {
    className: "vend_pos_svg__st1",
    d: "M177 70.54c-2.1-1.25-4.51-1.89-6.95-1.85-5.33 0-9.09 2.62-11.28 7.87a18.09 18.09 0 0 0-1.38 7c-.19 4.54 1.72 8.92 5.17 11.87 2.06 1.68 4.66 2.55 7.32 2.44 5.77 0 9.77-2.51 12-7.53.97-2.21 1.45-4.59 1.43-7-.03-6-2.14-10.26-6.31-12.8zM80.74 68.03c-2.95-.13-5.85.83-8.14 2.7-2.14 2-3.57 4.64-4.09 7.52H91.9c-.38-2.75-1.61-5.32-3.53-7.33a10.39 10.39 0 0 0-7.63-2.89z"
  })), vend_pos_path3 || (vend_pos_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M15.46 143.23a5.89 5.89 0 0 1 2.18-2.14c.9-.49 1.91-.74 2.93-.73a7.04 7.04 0 0 1 3 .61c.88.4 1.65 1 2.26 1.74.65.79 1.14 1.71 1.43 2.69.66 2.22.66 4.57 0 6.79-.3.99-.78 1.91-1.41 2.72-.62.76-1.39 1.38-2.27 1.82-.9.44-1.9.67-2.9.66-1.15.04-2.29-.23-3.3-.77a5.101 5.101 0 0 1-1.91-2v2.47h-2.59v-22h2.58v8.14zm4.71-.66c-1.35-.03-2.63.57-3.46 1.63a7.4 7.4 0 0 0-1.34 4.8c-.02.93.11 1.86.37 2.75.2.73.54 1.4 1 2 .41.49.94.88 1.53 1.13.59.25 1.23.38 1.88.38 1.4.04 2.73-.59 3.57-1.7a7.08 7.08 0 0 0 1.36-4.58c.09-1.65-.35-3.28-1.24-4.66a4.256 4.256 0 0 0-3.7-1.7l.03-.05zM38.24 157.95c-.22.65-.47 1.28-.76 1.9-.24.55-.58 1.05-1 1.48-.43.44-.96.78-1.53 1-.7.25-1.44.37-2.18.35-.61.01-1.22-.06-1.81-.2v-2c.23.02.46.02.69 0h.65c.51.02 1.02-.05 1.51-.21.38-.14.72-.36 1-.65.29-.33.51-.71.65-1.13.17-.43.34-.94.51-1.5h-.85l-5.78-16.35h2.79l4.74 14.34 4.3-14.34h2.63l-5.56 17.31zM56.69 154.68h10.18v2.41H54.08v-22h2.61v19.59zM71.12 134.66c.45 0 .88.17 1.2.49.31.29.49.7.49 1.13.01.45-.17.89-.49 1.21-.32.32-.75.49-1.2.49-.46 0-.89-.17-1.22-.49-.33-.31-.51-.75-.5-1.21 0-.43.18-.84.5-1.13.32-.32.76-.5 1.22-.49zm1.29 22.43h-2.57v-16.37h2.57v16.37zM91 141.94c-.51-.01-1.03.04-1.53.15-.41.09-.79.27-1.13.52.36.43.63.93.8 1.46.19.54.28 1.1.28 1.67.01.74-.16 1.47-.48 2.14-.32.63-.77 1.18-1.33 1.61-.63.46-1.34.8-2.09 1-.89.25-1.81.37-2.73.36-.58.01-1.15-.04-1.72-.15-.57-.12-1.13-.29-1.66-.52-.2.2-.38.42-.52.67-.12.22-.19.46-.2.71-.03.47.16.92.52 1.22.51.32 1.11.46 1.71.41h3.39c1.01-.02 2.02.1 3 .36.72.2 1.4.54 2 1 .49.38.88.89 1.13 1.46.23.57.34 1.17.34 1.78.02 1.45-.74 2.8-2 3.53a9.97 9.97 0 0 1-5.6 1.34c-1.17.02-2.33-.1-3.47-.35-.8-.18-1.57-.5-2.26-.94-.54-.34-.98-.82-1.27-1.39a3.724 3.724 0 0 1 1.64-5h.01c.16-.08.33-.15.5-.21a2.81 2.81 0 0 1-1.83-2.68c.09-1.11.71-2.1 1.67-2.67a4.87 4.87 0 0 1-1.38-1.58c-.34-.65-.51-1.38-.5-2.12 0-.69.14-1.37.41-2 .27-.66.7-1.25 1.24-1.72.59-.5 1.27-.89 2-1.13.92-.31 1.89-.46 2.86-.45.79-.01 1.58.09 2.35.27.65.16 1.27.41 1.85.73 1-1.21 2.52-1.85 4.08-1.72l-.08 2.24zm-11 13.33c-.61.29-1.14.72-1.56 1.25-.26.4-.4.87-.4 1.35-.02.82.41 1.59 1.13 2 1.22.61 2.59.87 3.95.75 1.31.08 2.62-.18 3.8-.75.77-.37 1.27-1.14 1.28-2 .01-.39-.07-.77-.22-1.13a1.78 1.78 0 0 0-.76-.82 4 4 0 0 0-1.42-.49c-.75-.11-1.51-.16-2.27-.15l-3.53-.01zm2.8-13c-1.11-.08-2.21.25-3.08.94-.67.62-1.04 1.5-1 2.41a3 3 0 0 0 .99 2.47c.86.64 1.93.96 3 .88 1.1.07 2.18-.24 3.08-.87.71-.6 1.1-1.5 1.06-2.43a3.13 3.13 0 0 0-1-2.43c-.86-.65-1.93-.96-3-.88l-.05-.09zM96.33 143.23c.52-.87 1.25-1.59 2.12-2.1.89-.5 1.9-.76 2.92-.75 1.58-.11 3.12.5 4.2 1.66a6.89 6.89 0 0 1 1.43 4.61v10.44h-2.58v-9.79c0-.64-.06-1.28-.17-1.91a4.11 4.11 0 0 0-.58-1.5c-.29-.42-.67-.77-1.13-1-.54-.24-1.14-.36-1.73-.34-1.22 0-2.38.52-3.18 1.44-.44.5-.77 1.08-1 1.7-.25.73-.37 1.49-.36 2.26V157h-2.56v-21.91h2.58l.04 8.14zM114.43 140.72H119v2h-4.58v10c-.04.66.14 1.32.51 1.87.5.51 1.2.76 1.91.67.48 0 .95-.04 1.42-.13.41-.07.82-.16 1.22-.28v2.07c-.47.16-.95.28-1.44.36-.56.1-1.14.15-1.71.15-.72.02-1.44-.09-2.12-.33-.53-.2-1-.51-1.39-.92-.36-.39-.62-.86-.75-1.38a6.39 6.39 0 0 1-.22-1.74V142.7h-2.33v-2h2.33v-4.36h2.57l.01 4.38zM128.3 140.38a9.92 9.92 0 0 1 3.74.64c1 .4 1.92.99 2.7 1.73l-1.54 1.54a7.025 7.025 0 0 0-2.16-1.31c-.87-.33-1.81-.49-2.74-.47-.96-.06-1.92.17-2.75.66-.61.35-.99.99-1 1.69-.02.35.06.69.22 1 .18.3.43.55.73.73.43.24.89.42 1.37.53.71.17 1.42.31 2.14.41.89.14 1.78.34 2.64.61.68.21 1.33.53 1.91.95.49.36.88.84 1.13 1.4.27.63.41 1.31.4 2 .03 1.39-.63 2.71-1.77 3.51-.65.46-1.38.8-2.16 1-.97.28-1.99.41-3 .39-1.43.02-2.86-.23-4.2-.74a8.4 8.4 0 0 1-3.07-2.06l1.66-1.63c.67.73 1.5 1.31 2.43 1.68 1 .39 2.06.59 3.13.58a5.8 5.8 0 0 0 3.28-.75c.65-.42 1.05-1.14 1.05-1.91.01-.36-.06-.72-.2-1.06-.17-.33-.44-.61-.76-.8-.46-.27-.96-.47-1.48-.61-.79-.21-1.6-.38-2.41-.49-1.55-.14-3.04-.7-4.3-1.61a3.802 3.802 0 0 1-1.35-3c-.01-.67.15-1.32.46-1.91.31-.57.74-1.06 1.27-1.44.6-.43 1.28-.74 2-.92.85-.24 1.74-.36 2.63-.34zM146.13 140.38c1.03-.03 2.06.18 3 .62.87.4 1.65 1 2.26 1.74.63.8 1.11 1.7 1.41 2.67.35 1.1.52 2.25.5 3.4.01 1.15-.14 2.29-.46 3.39-.28 1-.76 1.94-1.41 2.75-.61.77-1.38 1.39-2.26 1.83-.93.47-1.96.7-3 .68-1.09.03-2.16-.22-3.12-.73a5.194 5.194 0 0 1-2-2v7.44h-2.54v-21.45H141v2.45a6.009 6.009 0 0 1 5.19-2.79h-.06zm-.4 2.19c-1.36-.04-2.66.56-3.51 1.62a7.294 7.294 0 0 0-1.34 4.72c-.02.96.11 1.91.39 2.83.2.73.54 1.41 1 2 .41.49.92.88 1.5 1.13.59.25 1.23.38 1.87.38 1.4.05 2.73-.59 3.57-1.7a7.357 7.357 0 0 0 1.35-4.74c.01-.85-.09-1.7-.3-2.52a5.9 5.9 0 0 0-.93-2c-.4-.54-.93-.97-1.53-1.27-.65-.31-1.35-.46-2.07-.45zM163.39 140.38a6.6 6.6 0 0 1 5.38 2.49c.64.8 1.11 1.72 1.4 2.7.32 1.06.48 2.17.47 3.28v.59h-12.17c-.07 1.55.43 3.08 1.4 4.29a4.843 4.843 0 0 0 3.81 1.54c.98.03 1.96-.22 2.81-.71a5.7 5.7 0 0 0 1.83-1.89l2.14 1.13a8.015 8.015 0 0 1-2.81 2.68 8.372 8.372 0 0 1-4.07 1c-1.17.03-2.33-.2-3.39-.68a6.984 6.984 0 0 1-2.45-1.82 7.466 7.466 0 0 1-1.49-2.72c-.35-1.1-.52-2.24-.5-3.39-.01-1.13.15-2.26.49-3.34.29-.98.77-1.9 1.42-2.7a6.61 6.61 0 0 1 2.36-1.8c1.06-.47 2.21-.69 3.37-.65zm-.07 2.13c-1.27-.06-2.51.44-3.39 1.36-.86 1-1.36 2.27-1.41 3.59H168a6.002 6.002 0 0 0-1.34-3.6 4.13 4.13 0 0 0-3.35-1.35h.01zM180.71 140.38a6.62 6.62 0 0 1 5.39 2.49c.63.8 1.11 1.72 1.39 2.7.32 1.06.48 2.17.47 3.28v.59h-12.17c-.06 1.55.44 3.07 1.4 4.29.99 1.05 2.4 1.61 3.84 1.52.98.03 1.95-.22 2.8-.72.76-.47 1.39-1.12 1.84-1.89l2.14 1.13a8.043 8.043 0 0 1-2.81 2.69 8.372 8.372 0 0 1-4.07 1c-1.17.03-2.33-.2-3.4-.68a6.948 6.948 0 0 1-2.44-1.82c-.68-.8-1.19-1.72-1.5-2.72-.34-1.1-.51-2.24-.49-3.39-.01-1.13.15-2.26.48-3.34.29-.99.78-1.91 1.43-2.7.64-.77 1.44-1.39 2.35-1.8 1.05-.46 2.2-.67 3.35-.63zm-.06 2.13c-1.27-.06-2.51.44-3.39 1.36-.86 1-1.36 2.27-1.4 3.59h9.48c-.03-1.32-.5-2.58-1.34-3.6a4.13 4.13 0 0 0-3.35-1.35zM205.32 157.09h-2.58v-2.51c-.52.88-1.28 1.61-2.18 2.1-.92.51-1.95.77-3 .76-1.04.02-2.06-.2-3-.64-.88-.4-1.65-.99-2.26-1.74-.63-.79-1.1-1.69-1.39-2.66a11.89 11.89 0 0 1 0-6.79c.31-.99.79-1.91 1.43-2.72.6-.77 1.38-1.38 2.26-1.8a6.9 6.9 0 0 1 3-.65c1.08-.04 2.15.22 3.1.74.82.46 1.51 1.12 2 1.92v-7.92h2.58l.04 21.91zM198 142.57c-1.41-.07-2.77.57-3.62 1.7a7.51 7.51 0 0 0-1.27 4.64c-.1 1.63.33 3.25 1.21 4.63a4.2 4.2 0 0 0 3.65 1.68c1.35.03 2.64-.56 3.49-1.6 1-1.38 1.48-3.07 1.35-4.77a8.83 8.83 0 0 0-.38-2.75c-.2-.73-.54-1.4-1-2-.41-.49-.93-.88-1.52-1.14-.6-.26-1.25-.4-1.91-.39z"
  })), /*#__PURE__*/react.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h240.14v176.35H0z"
  }));
};
/* harmony default export */ var vend_pos = (SvgVendPos);
;// CONCATENATED MODULE: ./public/icons/tech-logos/nextjs.svg
var nextjs_circle, nextjs_g, nextjs_defs;
function nextjs_extends() { nextjs_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return nextjs_extends.apply(this, arguments); }

var SvgNextjs = function SvgNextjs(props) {
  return /*#__PURE__*/react.createElement("svg", nextjs_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("mask", {
    id: "nextjs_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 180,
    height: 180
  }, nextjs_circle || (nextjs_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#000"
  }))), nextjs_g || (nextjs_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#nextjs_svg__a)"
  }, /*#__PURE__*/react.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 87,
    fill: "currentColor",
    stroke: "transparent",
    strokeWidth: 6
  }), /*#__PURE__*/react.createElement("path", {
    d: "M149.508 157.52 69.142 54H54v71.97h12.114V69.384l73.885 95.461a90.304 90.304 0 0 0 9.509-7.325Z",
    fill: "url(#nextjs_svg__b)"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "url(#nextjs_svg__c)",
    d: "M115 54h12v72h-12z"
  }))), nextjs_defs || (nextjs_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "nextjs_svg__b",
    x1: 109,
    y1: 116.5,
    x2: 144.5,
    y2: 160.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "nextjs_svg__c",
    x1: 121,
    y1: 54,
    x2: 120.799,
    y2: 106.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
/* harmony default export */ var nextjs = (SvgNextjs);
;// CONCATENATED MODULE: ./public/icons/tech-logos/express.svg
var express_path;
function express_extends() { express_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return express_extends.apply(this, arguments); }

var SvgExpress = function SvgExpress(props) {
  return /*#__PURE__*/react.createElement("svg", express_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), express_path || (express_path = /*#__PURE__*/react.createElement("path", {
    d: "M32 24.795c-1.164.296-1.884.013-2.53-.957l-4.594-6.356-.664-.88-5.365 7.257c-.613.873-1.256 1.253-2.4.944l6.87-9.222-6.396-8.33c1.1-.214 1.86-.105 2.535.88l4.765 6.435 4.8-6.4c.615-.873 1.276-1.205 2.38-.883l-2.48 3.288-3.36 4.375c-.4.5-.345.842.023 1.325L32 24.795zM.008 15.427l.562-2.764C2.1 7.193 8.37 4.92 12.694 8.3c2.527 1.988 3.155 4.8 3.03 7.95H1.48c-.214 5.67 3.867 9.092 9.07 7.346 1.825-.613 2.9-2.042 3.438-3.83.273-.896.725-1.036 1.567-.78-.43 2.236-1.4 4.104-3.45 5.273-3.063 1.75-7.435 1.184-9.735-1.248C1 21.6.434 19.812.18 17.9c-.04-.316-.12-.617-.18-.92q.008-.776.008-1.552zm1.498-.38h12.872c-.084-4.1-2.637-7.012-6.126-7.037-3.83-.03-6.58 2.813-6.746 7.037z"
  })));
};
/* harmony default export */ var express = (SvgExpress);
;// CONCATENATED MODULE: ./public/icons/tech-logos/liquid.svg
var liquid_path;
function liquid_extends() { liquid_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return liquid_extends.apply(this, arguments); }

var SvgLiquid = function SvgLiquid(props) {
  return /*#__PURE__*/react.createElement("svg", liquid_extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.54 22.48"
  }, props), liquid_path || (liquid_path = /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M33.21 16.28a9.87 9.87 0 0 0-5.84 1.78l.52.85-.52-.85.52.85-.52-.85A7.08 7.08 0 0 1 23 19.41a7.07 7.07 0 0 1-4.35-1.35 9.87 9.87 0 0 0-5.84-1.78A9.86 9.86 0 0 0 7 18.06a7.08 7.08 0 0 1-4.35 1.35 8.59 8.59 0 0 1-1.45-.11L0 19.1v3.12l.85.13a11.42 11.42 0 0 0 1.77.13 9.87 9.87 0 0 0 5.84-1.78 7.08 7.08 0 0 1 4.35-1.35 7.08 7.08 0 0 1 4.35 1.35A9.87 9.87 0 0 0 23 22.48a9.87 9.87 0 0 0 5.84-1.78 7.08 7.08 0 0 1 4.35-1.35h1.33v-3.03h-1.31zM33.46 0h-.25a9.89 9.89 0 0 0-5.87 1.82A7.12 7.12 0 0 1 23 3.16a7.14 7.14 0 0 1-4.35-1.35A9.86 9.86 0 0 0 12.82 0 9.88 9.88 0 0 0 7 1.82a7.07 7.07 0 0 1-4.38 1.35 8.46 8.46 0 0 1-1.45-.11L0 2.86V6l.84.11a11.31 11.31 0 0 0 1.77.13 9.86 9.86 0 0 0 5.85-1.77 7.07 7.07 0 0 1 4.35-1.35 7.07 7.07 0 0 1 4.35 1.35A9.85 9.85 0 0 0 23 6.24a9.85 9.85 0 0 0 5.84-1.78 7.15 7.15 0 0 1 4.35-1.35h1.33V0zm-.25 8.16a9.87 9.87 0 0 0-5.84 1.78l.52.85-.52-.85A7.08 7.08 0 0 1 23 11.29a7.07 7.07 0 0 1-4.35-1.35 9.87 9.87 0 0 0-5.84-1.78A9.87 9.87 0 0 0 7 9.94a7.08 7.08 0 0 1-4.35 1.35 8.46 8.46 0 0 1-1.45-.11L0 11v3.12l.85.13a11.46 11.46 0 0 0 1.77.13 9.87 9.87 0 0 0 5.84-1.78 7.08 7.08 0 0 1 4.35-1.35 7.08 7.08 0 0 1 4.35 1.35A9.87 9.87 0 0 0 23 14.36a9.86 9.86 0 0 0 5.84-1.78 7.07 7.07 0 0 1 4.35-1.35h1.33V8.2h-1.31z"
  })));
};
/* harmony default export */ var liquid = (SvgLiquid);
;// CONCATENATED MODULE: ./content/tech-stack.tsx







































































var TECH = {
    shopify: {
        name: "Shopify",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiShopify/* SiShopify */.F, {
                className: className
            });
        }
    },
    spring: {
        name: "Spring",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiSpring/* SiSpring */.C, {
                className: className
            });
        }
    },
    hibernate: {
        name: "Hibernate"
    },
    kafka: {
        name: "Apache Kafka"
    },
    junit: {
        name: "JUnit"
    },
    mockito: {
        name: "Mockito"
    },
    micrometer: {
        name: "Microrometer"
    },
    insomnia: {
        name: "Insomnia"
    },
    vscode: {
        name: "Visual Studio Code"
    },
    dbeaver: {
        name: "DBeaver"
    },
    oraclesql: {
        name: "Oracle SQL Developer"
    },
    maven: {
        name: "Maven"
    },
    gradle: {
        name: "Gradle"
    },
    oraclecloud: {
        name: "Oracle Cloud"
    },
    gcp: {
        name: "Google Cloud Plataform"
    },
    selenium: {
        name: "Selenium"
    },
    lombok: {
        name: "Lombok"
    },
    swing: {
        name: "Swing X"
    },
    gson: {
        name: "Gson"
    },
    shopify_polaris: {
        name: "Shopify Polaris",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiShopify/* SiShopify */.F, {
                className: className
            });
        }
    },
    vend: {
        name: "Vend POS",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(vend_pos, {
                className: className
            });
        }
    },
    typescript: {
        name: "TypeScript",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiTypescript/* SiTypescript */.W, {
                className: className
            });
        }
    },
    vercel: {
        name: "Vercel",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(IoLogoVercel/* IoLogoVercel */.L, {
                className: className
            });
        }
    },
    netlify: {
        name: "Netlify",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiNetlify/* SiNetlify */.B, {
                className: className
            });
        }
    },
    sass: {
        name: "Sass",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(IoLogoSass/* IoLogoSass */.r, {
                className: className
            });
        }
    },
    liquid: {
        name: "Liquid",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(liquid, {
                className: className
            });
        }
    },
    nextjs: {
        name: "Next.js",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(nextjs, {
                className: className
            });
        }
    },
    markdown: {
        name: "Markdown",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiMarkdown/* SiMarkdown */.i, {
                className: className
            });
        }
    },
    mdx: {
        name: "Mdx",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(mdx, {
                className: className
            });
        }
    },
    graphql: {
        name: "GraphQL",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiGraphql/* SiGraphql */.d, {
                className: className
            });
        }
    },
    reactjs: {
        name: "React.js",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiReact/* SiReact */.p, {
                className: className
            });
        }
    },
    tailwind: {
        name: "TailwindCSS",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiTailwindcss/* SiTailwindcss */.Y, {
                className: className
            });
        }
    },
    prisma: {
        name: "Prisma",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(prisma, {
                className: className
            });
        }
    },
    planetscale: {
        name: "PlanetScale",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(planetscale, {
                className: className
            });
        }
    },
    trpc: {
        name: "Trpc",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(trpc, {
                className: className
            });
        }
    },
    aws: {
        name: "AWS",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaAws/* FaAws */.U, {
                className: className
            });
        }
    },
    aws_amplify: {
        name: "Aws Amplify",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(aws_amplify, {
                className: className
            });
        }
    },
    aws_lambda: {
        name: "Aws Lambda",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(aws_lambda, {
                className: className
            });
        }
    },
    axios: {
        name: "Axios",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(axios, {
                className: className
            });
        }
    },
    chrome: {
        name: "Chrome",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiGooglechrome/* SiGooglechrome */.L, {
                className: className
            });
        }
    },
    css_3: {
        name: "CSS",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiCss3/* SiCss3 */.H, {
                className: className
            });
        }
    },
    emmet: {
        name: "Emmet",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(emmet, {
                className: className
            });
        }
    },
    eslint: {
        name: "Eslint",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiEslint/* SiEslint */.x, {
                className: className
            });
        }
    },
    facebook: {
        name: "Facebook",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiFacebook/* SiFacebook */.u, {
                className: className
            });
        }
    },
    figma: {
        name: "Figma",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiFigma/* SiFigma */.e, {
                className: className
            });
        }
    },
    sketch: {
        name: "Sketch",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiSketch/* SiSketch */.p, {
                className: className
            });
        }
    },
    firebase: {
        name: "Firebase",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiFirebase/* SiFirebase */.x, {
                className: className
            });
        }
    },
    framer: {
        name: "Framer",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiFramer/* SiFramer */.H, {
                className: className
            });
        }
    },
    git: {
        name: "Git",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiGit/* SiGit */.z, {
                className: className
            });
        }
    },
    github: {
        name: "Github",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiGithub/* SiGithub */.p, {
                className: className
            });
        }
    },
    headlessui: {
        name: "Headless Ui",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui, {
                className: className
            });
        }
    },
    html_5: {
        name: "HTML",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiHtml5/* SiHtml5 */.P, {
                className: className
            });
        }
    },
    intellij_idea: {
        name: "Intellij Idea",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiIntellijidea/* SiIntellijidea */.A, {
                className: className
            });
        }
    },
    ionic: {
        name: "Ionic",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiIonic/* SiIonic */.w, {
                className: className
            });
        }
    },
    javascript: {
        name: "JavaScript",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiJavascript/* SiJavascript */.v, {
                className: className
            });
        }
    },
    java: {
        name: "Java",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiJava/* SiJava */.L, {
                className: className
            });
        }
    },
    kotlin: {
        name: "Kotlin",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiKotlin/* SiKotlin */.a, {
                className: className
            });
        }
    },
    jenkins: {
        name: "Jenkins",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiJenkins/* SiJenkins */.h, {
                className: className
            });
        }
    },
    jest: {
        name: "Jest",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiJest/* SiJest */.Z, {
                className: className
            });
        }
    },
    jsdom: {
        name: "Jsdom",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsdom, {
                className: className
            });
        }
    },
    mysql: {
        name: "MySQL",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiMysql/* SiMysql */.u, {
                className: className
            });
        }
    },
    nodejs: {
        name: "Node.js",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiNodeDotJs/* SiNodeDotJs */.t, {
                className: className
            });
        }
    },
    express: {
        name: "Express",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(express, {
                className: className
            });
        }
    },
    preact: {
        name: "Preact",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(preact, {
                className: className
            });
        }
    },
    prettier: {
        name: "Prettier",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiPrettier/* SiPrettier */.n, {
                className: className
            });
        }
    },
    react: {
        name: "React.js",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiReact/* SiReact */.p, {
                className: className
            });
        }
    },
    dev_tools: {
        name: "Dev Tools",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MdDesktopMac/* MdDesktopMac */.n, {
                className: className
            });
        }
    },
    office: {
        name: "MS Office",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiMicrosoftoffice/* SiMicrosoftoffice */.t, {
                className: className
            });
        }
    },
    react_query: {
        name: "React Query",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_query, {
                className: className
            });
        }
    },
    redis: {
        name: "Redis",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiRedis/* SiRedis */.N, {
                className: className
            });
        }
    },
    remix: {
        name: "Remix",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(remix, {
                className: className
            });
        }
    },
    sendgrid: {
        name: "SendGrid",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(sendgrid, {
                className: className
            });
        }
    },
    stylelint: {
        name: "Stylelint",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(stylelint, {
                className: className
            });
        }
    },
    swc: {
        name: "SWC",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swc, {
                className: className
            });
        }
    },
    tailwindcss: {
        name: "Tailwindcss",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiTailwindcss/* SiTailwindcss */.Y, {
                className: className
            });
        }
    },
    takealot: {
        name: "Takealot",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(takealot, {
                className: className
            });
        }
    },
    turborepo: {
        name: "Turborepo",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(turborepo, {
                className: className
            });
        }
    },
    webpack: {
        name: "Webpack",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiWebpack/* SiWebpack */.u, {
                className: className
            });
        }
    },
    yarn: {
        name: "Yarn",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiYarn/* SiYarn */.F, {
                className: className
            });
        }
    },
    npm: {
        name: "NPM",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiNpm/* SiNpm */.E, {
                className: className
            });
        }
    },
    sql: {
        name: "SQL",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AiOutlineConsoleSql/* AiOutlineConsoleSql */.j, {
                className: className
            });
        }
    },
    ruby: {
        name: "Ruby",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiRuby/* SiRuby */.N, {
                className: className
            });
        }
    },
    php: {
        name: "PHP",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiPhp/* SiPhp */.s, {
                className: className
            });
        }
    },
    illustrator: {
        name: "Illustrator",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiAdobeillustrator/* SiAdobeillustrator */.Q, {
                className: className
            });
        }
    },
    photoshop: {
        name: "Photoshop",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiAdobephotoshop/* SiAdobephotoshop */.d, {
                className: className
            });
        }
    },
    postman: {
        name: "Postman",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiPostman/* SiPostman */.n, {
                className: className
            });
        }
    },
    erply: {
        Icon: null,
        name: "Erply POS"
    },
    dear: {
        Icon: null,
        name: "Dear POS"
    },
    micros: {
        Icon: null,
        name: "Micros POS"
    },
    wordpress: {
        name: "WordPress",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiWordpress/* SiWordpress */.V, {
                className: className
            });
        }
    },
    ftp: {
        name: "Ftp",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImUpload/* ImUpload */.b, {
                className: className
            });
        }
    },
    meta: {
        name: "Meta Ads & Facebook Business suite",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImUpload/* ImUpload */.b, {
                className: className
            });
        }
    },
    google: {
        name: "Google Ads, Merchant & Analytics",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImUpload/* ImUpload */.b, {
                className: className
            });
        }
    },
    instagram: {
        name: "Instagram",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiInstagram/* SiInstagram */.P, {
                className: className
            });
        }
    },
    omnisend: {
        name: "Omnisend Email Marketing",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiInstagram/* SiInstagram */.P, {
                className: className
            });
        }
    },
    asana: {
        name: "Asana",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiInstagram/* SiInstagram */.P, {
                className: className
            });
        }
    },
    clockify: {
        name: "Clockify",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiInstagram/* SiInstagram */.P, {
                className: className
            });
        }
    },
    msTeams: {
        name: "Microsoft Teams",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiMicrosoftteams/* SiMicrosoftteams */.n, {
                className: className
            });
        }
    },
    zoom: {
        name: "Zoom",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiInstagram/* SiInstagram */.P, {
                className: className
            });
        }
    },
    slack: {
        name: "Slack",
        Icon: function(param) {
            var className = param.className;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiInstagram/* SiInstagram */.P, {
                className: className
            });
        }
    }
};


/***/ }),

/***/ 54096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ capitalize; }
/* harmony export */ });
var capitalize = function(string) {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : undefined;
};


/***/ })

}]);